/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * POAM creation request
 * @export
 * @interface POAMCreateRequest
 */
export interface POAMCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof POAMCreateRequest
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMCreateRequest
     */
    itemTitle?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMCreateRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMCreateRequest
     */
    findingId?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMCreateRequest
     */
    importSspId?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMCreateRequest
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMCreateRequest
     */
    priority?: string;
    /**
     * 
     * @type {Date}
     * @memberof POAMCreateRequest
     */
    dueDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof POAMCreateRequest
     */
    remarks?: string;
    /**
     * 
     * @type {string}
     * @memberof POAMCreateRequest
     */
    budget?: string;
}

/**
 * Check if a given object implements the POAMCreateRequest interface.
 */
export function instanceOfPOAMCreateRequest(value: object): value is POAMCreateRequest {
    return true;
}

export function POAMCreateRequestFromJSON(json: any): POAMCreateRequest {
    return POAMCreateRequestFromJSONTyped(json, false);
}

export function POAMCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): POAMCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'] == null ? undefined : json['title'],
        'itemTitle': json['itemTitle'] == null ? undefined : json['itemTitle'],
        'description': json['description'] == null ? undefined : json['description'],
        'findingId': json['findingId'] == null ? undefined : json['findingId'],
        'importSspId': json['importSspId'] == null ? undefined : json['importSspId'],
        'status': json['status'] == null ? undefined : json['status'],
        'priority': json['priority'] == null ? undefined : json['priority'],
        'dueDate': json['dueDate'] == null ? undefined : (new Date(json['dueDate'])),
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
        'budget': json['budget'] == null ? undefined : json['budget'],
    };
}

export function POAMCreateRequestToJSON(json: any): POAMCreateRequest {
    return POAMCreateRequestToJSONTyped(json, false);
}

export function POAMCreateRequestToJSONTyped(value?: POAMCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'itemTitle': value['itemTitle'],
        'description': value['description'],
        'findingId': value['findingId'],
        'importSspId': value['importSspId'],
        'status': value['status'],
        'priority': value['priority'],
        'dueDate': value['dueDate'] == null ? undefined : ((value['dueDate']).toISOString()),
        'remarks': value['remarks'],
        'budget': value['budget'],
    };
}

